import {
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Grid,
  TextField,
  Divider,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  debounce,
} from "@mui/material";
import { Transition } from "../../../../../../components";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { useGeolocalizacaoService, useProjetosService } from "../../../../../../../use-cases/geo-veles";
import { GetGeolocationTypeLabel, onlyNumbers } from "../../../../../../../utils";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import { MapContainer, Polygon, TileLayer } from "react-leaflet";
import { useEffect, useState } from "react";
import { theme } from "../../../../../../styles";
// Icons
import markerIcon from "../../../../../../../assets/img/marker-icon.png";
import SearchIcon from "@mui/icons-material/Search";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import CloseIcon from "@mui/icons-material/Close";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import PushPinIcon from "@mui/icons-material/PushPin";
import SouthAmericaIcon from "@mui/icons-material/SouthAmerica";
import TrafficIcon from "@mui/icons-material/Traffic";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import NaturePeopleIcon from "@mui/icons-material/NaturePeople";
import SignpostIcon from "@mui/icons-material/Signpost";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { ResetCenterView } from "./ResetCenterView";

// Corrige o ícone padrão do Leaflet (necessário para produção)
L.Icon.Default.prototype.options.iconRetinaUrl = markerIcon2x;
L.Icon.Default.prototype.options.iconUrl = markerIcon;
L.Icon.Default.prototype.options.shadowUrl = markerShadow;

export const GeolocalizacaoDialog = () => {

  // State
  const { geolocalizacao, projetos } = useAppSelector((state) => state);
  // Hook
  const { setGeolocalizacaoFilter } = useProjetosService();
  const {
    setSearchTerm,
    setGeolocalizacaoRadius,
    setGeolocalizacaoOpen,
    openGeolocalizacaoDialog,
    getGeolocalizacao,
    getGeolocalizacaoByLatLon,
    setSelectedGeolocalizacao, 
    resetSelectedGeolocalizacao,
    resetGeolocalizacoesEncontradas,
    resetSearchTerm,
    resetRadius
  } = useGeolocalizacaoService();
  // Use State
  const [latLon, setLatLon] = useState<[number, number] | null>(null);

  useEffect(() => {
    if (!geolocalizacao.selectedGeolocalizacao) {     
        // resetSearchTerm()
        // resetRadius()
    }  
  })

  useEffect(() => {
    if (projetos.filtrosSelecionados?.geolocalizacao) {
      if (geolocalizacao.selectedGeolocalizacao) {
        setLatLon([
          geolocalizacao.selectedGeolocalizacao.lat,
          geolocalizacao.selectedGeolocalizacao.lon,
        ]);
      } 
      else {
        navigator.geolocation.getCurrentPosition(function (
            position
          ) {
            if (position.coords) {
              getGeolocalizacaoByLatLon({
                lat: position.coords.latitude,
                lon: position.coords.longitude,
              });
            }
          });
      }
    }
    else {
        navigator.geolocation.getCurrentPosition(function (
            position
          ) {
            if (position.coords) {
              getGeolocalizacaoByLatLon({
                lat: position.coords.latitude,
                lon: position.coords.longitude,
              });
            }
          });
      }
  }, [
    geolocalizacao.selectedGeolocalizacao,    
    projetos.filtrosSelecionados?.geolocalizacao,
  ]);  

  return (
    <>
      <Dialog
        fullScreen
        open={geolocalizacao.openDialog}
        TransitionComponent={Transition}
        onClose={() => {
          openGeolocalizacaoDialog(false);
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              textTransform="uppercase"
              variant="h6"
              component="div"
            >
              Selecionar geolocalização
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={() => {
                //alert("Aguarde, estamos carregando sua localização atual.");
                resetSearchTerm()
                resetRadius()
                resetSelectedGeolocalizacao();
                resetGeolocalizacoesEncontradas();
                openGeolocalizacaoDialog(false);
              }}
            >
              Fechar
            </Button>
          </Toolbar>
        </AppBar>

        <Box p={5}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (geolocalizacao.selectedGeolocalizacao?.name !== "") {
                resetSelectedGeolocalizacao();
              }

              if (
                (geolocalizacao.geolocalizacoesEncontradas ?? []).length > 0
              ) {
                resetGeolocalizacoesEncontradas();
              }

              getGeolocalizacao();
            }}
          >
            <Grid
              container
              mb={3}
              display={"flex"}
              justifyContent={"space-between"}
            >
              <Grid
                item
                //xs={geolocalizacao.selectedGeolocalizacao ? 7 : 12}
                xs={7}

                display={"flex"}
                alignItems={"center"}
                my={1}
              >
                <TextField
                  defaultValue={geolocalizacao.searchTerm}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="dense"
                  label="Digite um CEP, bairro, cidade, estado ou região"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={debounce((e) => {
                    setSearchTerm({
                      searchTerm: e.target.value,
                    });
                  }, 0)}
                />
              </Grid>
              {/* {geolocalizacao.selectedGeolocalizacao ? ( */}
                <>
                  <Grid
                    item
                    xs={1}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Divider
                      orientation="vertical"
                      color={theme.palette.primary.main}
                      style={{ marginTop: "20px" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    display={"flex"}
                    alignItems={"center"}
                    my={1}
                  >
                    <TextField
                      value={geolocalizacao.radius / 1000}
                      margin="dense"
                      label="Digite um raio (em km)"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => {
                        const formatNumber = Number(
                          onlyNumbers(e.target.value)
                        );
                        setGeolocalizacaoRadius({
                          radius: formatNumber * 1000,
                        });
                      }}
                    />
                  </Grid>
                </>
              {/* ) : null} */}
              <Grid
                item
                xs={7}
                my={1}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  endIcon={<SearchIcon />}
                >
                  Pesquisar
                </Button>
              </Grid>
              <Grid
                item
                xs={1}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Divider
                  orientation="vertical"
                  color={theme.palette.primary.main}
                />
              </Grid>
              <Grid
                item
                xs={3}
                my={1}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  endIcon={<MyLocationIcon />}
                  onClick={(e) => {
                    navigator.geolocation.getCurrentPosition(function (
                      position
                    ) {
                      if (position.coords) {
                        getGeolocalizacaoByLatLon({
                          lat: position.coords.latitude,
                          lon: position.coords.longitude,
                        });
                      }
                    });
                  }}
                >
                  Meu local
                </Button>
              </Grid>
            </Grid>
          </form>
          <MapContainer
            center={[
              latLon ? latLon[0] : -23.59499168284,
              latLon ? latLon[1] : -46.689440331743,
            ]}
            zoom={15}
            minZoom={4}
          >
            <TileLayer
              attribution=""
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <ResetCenterView latLon={latLon} />
            {geolocalizacao.selectedGeolocalizacao ? (
              geolocalizacao.selectedGeolocalizacao.latLon ? (
                geolocalizacao.selectedGeolocalizacao.latLon.type !==
                "Point" ? (
                  geolocalizacao.selectedGeolocalizacao.latLon.type ===
                  "MultiPolygon" ? (
                    geolocalizacao.selectedGeolocalizacao.latLon.coordinates.map(
                      (coordinate: any) => {
                        return (
                          <>
                            <Polygon
                              pmIgnore={true}
                              pathOptions={{
                                color: theme.palette.primary.main,
                              }}
                              positions={coordinate.map((coordinate: any) => {
                                return [coordinate[1], coordinate[0]];
                              })}
                            />
                          </>
                        );
                      }
                    )
                  ) : (
                    <>
                      <Polygon
                        pmIgnore={true}
                        pathOptions={{ color: theme.palette.primary.main }}
                        positions={geolocalizacao.selectedGeolocalizacao.latLon.coordinates.map(
                          (coordinate) => {
                            return [coordinate[1], coordinate[0]];
                          }
                        )}
                      />
                    </>
                  )
                ) : null
              ) : null
            ) : null}
          </MapContainer>
        </Box>
      </Dialog>

      <Dialog
        maxWidth="md"
        open={geolocalizacao.open}
        onClose={() => {
          setGeolocalizacaoOpen({
            open: false,
          });
        }}
      >
        <Grid container display={"flex"}>
          <Grid
            item
            xs={12}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <DialogTitle
              color="primary"
              fontWeight={"bold"}
              textTransform={"uppercase"}
              sx={{
                flexGrow: 1,
                textAlign: "center",
              }}
            >
              Localizações encontradas
            </DialogTitle>
            <IconButton
              onClick={() => {
                setGeolocalizacaoOpen({
                  open: false,
                });
              }}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Divider color={theme.palette.primary.main} />
        </Grid>
        <List>
          {geolocalizacao.geolocalizacoesEncontradas
            ? geolocalizacao.geolocalizacoesEncontradas.map(
                (geolocation, index) => {
                  return (
                    <>
                      <Grid
                        key={index}
                        container
                        display={"flex"}
                        alignItems={"center"}
                      >
                        <ListItem
                          key={index}
                          button
                          onClick={() => {
                            setSelectedGeolocalizacao({
                              geolocalizacao: geolocation,
                            });
                            setGeolocalizacaoOpen({
                              open: false,
                            });
                            setGeolocalizacaoFilter({
                              geolocalizacao: {
                                data: geolocation,
                                radius: geolocalizacao.radius,
                              },
                            });



                            
                          }}
                        >
                          <Grid
                            item
                            xs={1.5}
                            display={"flex"}
                            justifyContent={"center"}
                          >
                            {geolocation.placeRank === 4 ? (
                              <FlagCircleIcon />
                            ) : geolocation.placeRank >= 5 &&
                              geolocation.placeRank <= 9 ? (
                              <SouthAmericaIcon />
                            ) : geolocation.placeRank >= 10 &&
                              geolocation.placeRank <= 12 ? (
                              <TrafficIcon />
                            ) : geolocation.placeRank >= 13 &&
                              geolocation.placeRank <= 16 ? (
                              <LocationCityIcon />
                            ) : geolocation.placeRank >= 17 &&
                              geolocation.placeRank <= 24 ? (
                              <NaturePeopleIcon />
                            ) : geolocation.placeRank >= 26 &&
                              geolocation.placeRank <= 27 ? (
                              <SignpostIcon />
                            ) : geolocation.placeRank >= 28 &&
                              geolocation.placeRank <= 30 ? (
                              <AccountBalanceIcon />
                            ) : (
                              <PushPinIcon />
                            )}
                          </Grid>
                          <Grid item xs={10}>
                            <ListItemText
                              primary={geolocation.name}
                              secondary={GetGeolocationTypeLabel(
                                geolocation.placeRank
                              )}
                            />
                          </Grid>
                        </ListItem>
                      </Grid>
                      <Divider color={theme.palette.primary.main} />
                    </>
                  );
                }
              )
            : null}
        </List>
      </Dialog>
    </>
  );
};